import { LINK_APPLICATION } from "../Constants/LinkMyApplicationConstants";
import api from "./AxiosInterceptor";
import EndpointService from "./EndpointService";

export const postLinkApplicationService = async (data) => {
  const url = EndpointService("applicationSearch");
  const payload = {
    hapId: data.hapId,
    dateOfBirth: data.dateOfBirth,
    screenType: LINK_APPLICATION,
  };
  const response = await api.post(url, payload);
  return response;
};
export const postSearchLinkApplicationService = async (payload) => {
  const url = EndpointService("applicationSearch");
  const response = await api.post(url, {
    firstName: payload.firstName,
    lastName: payload.lastName,
    zipCode: payload.zipCode,
    sexCode: payload.sexCode.value,
    dateOfBirth: payload.dateOfBirth,
    screenType: LINK_APPLICATION,
  });
  return response;
};
